import { render, staticRenderFns } from "./NavbarCollectionsPhone.vue?vue&type=template&id=914bca38&scoped=true&"
import script from "./NavbarCollectionsPhone.vue?vue&type=script&lang=js&"
export * from "./NavbarCollectionsPhone.vue?vue&type=script&lang=js&"
import style0 from "./NavbarCollectionsPhone.vue?vue&type=style&index=0&id=914bca38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914bca38",
  null
  
)

export default component.exports